import React, { useState, useEffect, useRef } from "react";
import { Box } from "@mui/material";
import HighlightsMovies from "../util/AutoCompleteHintMovie";
import HighlightsPhrases from "../util/AutoCompleteHintPhrases";
import GetData from "../util/Fetch/GetData";
import Loader from "../components/GetClip/Loader";
import Alert from "@mui/material/Alert";

const GetClip = () => {
    //States
    const [ClipUrl, setClipUrl] = useState("");
    const [Movies, setMovies] = useState([]);
    const [MovieClips, setMovieClips] = useState([]);
    const [LoadingPhrases, setLoadingPhrases] = useState(false);
    const [LoadingVideo, setLoadingVideo] = useState(false);

    //Element refs
    const clipVideoRef = useRef(null);

    //Get all the avalable movies in the backend
    useEffect(() => {
        GetData("/api/clips/movies/").then((data) => {
            setMovies(data);
        });
    }, []);

    //// This effect ensures the video player reloads whenever clipUrl changes.
    useEffect(() => {
        if (clipVideoRef.current) {
            clipVideoRef.current.load();
        }
    }, [ClipUrl]);

    //Handle movie select
    function handleMovieSelected(selectedMovie) {
        // Use the movie id to get all the phrase data
        if (selectedMovie) {
            setLoadingPhrases(true);
            GetData(`/api/clips/movies/movie/${selectedMovie.id}/`).then(
                (data) => {
                    setMovieClips(data);
                    setLoadingPhrases(false);
                }
            );
        }
    }

    //Handle movie clear
    function handleMovieCleared() {
        //Set the MovieClips to empty when movie is cleared
        setMovieClips([]);
        setClipUrl("");
    }

    //Handle phrase selection
    function handlePhraseSelected(selectedPhrase) {
        // Use the movie id to get all the phrase data
        if (selectedPhrase) {
            //The clip video has started loading
            setLoadingVideo(true);

            const clip_url = selectedPhrase.clip_url;

            // Function to normalize the slash before "output"
            function normalizeSlashAndRemovePrefix(path) {
                // First, remove the "clipped_videos/" part
                let newPath = path.replace(/^clipped_videos\//, "");

                // Then, replace multiple slashes with a single slash before "output"
                newPath = newPath.replace(/\/+(output)/g, "/$1");

                return newPath;
            }
            const signed_clipVideo_url = `/api/clips/signed-url/${encodeURIComponent(
                normalizeSlashAndRemovePrefix(clip_url)
            )}/`;

            GetData(signed_clipVideo_url).then((data) => {
                setClipUrl(data.url);
            });
        }
    }

    //Handle phrase clear
    function handlePhraseCleared() {
        //Clear the clip video url if the phrase was cleared
        setClipUrl("");
    }

    //Get to know when the clip video has loaded
    const handleClipVideoLoad = () => {
        // Set clip video loading to true
        setLoadingVideo(false);
    };

    // Function to handle the right-click
    const handleContextMenu = (event) => {
        event.preventDefault();
        // You can also add your custom logic here
        alert("Hey no right clicking on the video. No!, No!, No!")
    };

    return (
        <Box
            className="movie-search"
            sx={{
                mt: "30px",
            }}
        >
            <Box
                sx={{
                    display: "block",
                    margin: "0 auto",
                    width: ["95%", "fit-content", "fit-content", "fit-content"],
                }}
            >
                <HighlightsMovies
                    Label="Movies"
                    Options={Movies && Movies}
                    Disabled={Movies && Movies.length === 0}
                    onOptionSelected={handleMovieSelected}
                    onInputCleared={handleMovieCleared}
                />
                {LoadingPhrases ? (
                    <Loader Text="Loading Phrases!" />
                ) : (
                    <Box></Box>
                )}
                <HighlightsPhrases
                    Label="Type your phrase"
                    Options={MovieClips && MovieClips}
                    Disabled={MovieClips && MovieClips.length === 0}
                    onOptionSelected={handlePhraseSelected}
                    onInputCleared={handlePhraseCleared}
                />
                {LoadingVideo ? (
                    <Loader Text="Loading Clip Video!" />
                ) : (
                    <Box></Box>
                )}
            </Box>

            <Box
                sx={{
                    margin: "0 auto",
                    mt: "20px",
                    width: ["95%", "500px", "500px", "500px"],
                    display: "block",
                }}
            >
                <video
                    width="100%"
                    controls
                    ref={clipVideoRef}
                    onLoadedData={handleClipVideoLoad}
                    onContextMenu={handleContextMenu}
                >
                    <source src={ClipUrl} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>

                {ClipUrl !== "" ? (
                    <Alert sx={{ marginTop: "10px" }} severity="info">
                        This video will expire in 4 min.
                    </Alert>
                ) : (
                    <Box></Box>
                )}
            </Box>
        </Box>
    );
};

export default GetClip;
